import { FC, useContext } from 'react';

import { H3, Link, Separator, Tooltip } from '@smartshell/ui-kit';

import { LINKS } from 'links';
import { LocalizationContext } from 'localization';

import { Password } from './components/Password';
import s from './ShellPassword.module.scss';

export const ShellPassword: FC = () => {
  const { t, lang } = useContext(LocalizationContext);

  return (
    <div className={s.container}>
      <div className={s.header}>
        <H3>{t('setting.shell.password')}</H3>
        <Tooltip
          contentClassName={s.tooltip_content}
          content={
            <div className={s.tooltip}>
              <H3>{t('setting.shell.password')}</H3>
              <span className={s.tooltip_subtitle}>
                {t('settings.shell.security.tooltip.description')}
              </span>
              <Link title={t('more')} link={LINKS.shell_settings[lang]} />
            </div>
          }
        />
      </div>
      <span className={s.subtitle}>
        {t('setting.shell.password.description')}
      </span>
      <Separator style={{ margin: '16px 0' }} />
      <Password />
    </div>
  );
};
